var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#166DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 448C150.4 448 64 361.6 64 256C64 150.4 150.4 64 256 64C361.6 64 448 150.4 448 256C448 361.6 361.6 448 256 448Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 384C185.6 384 128 326.4 128 256C128 185.6 185.6 128 256 128C326.4 128 384 185.6 384 256C384 326.4 326.4 384 256 384Z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 320C220.8 320 192 291.2 192 256C192 220.8 220.8 192 256 192C291.2 192 320 220.8 320 256C320 291.2 291.2 320 256 320Z",
    fill: "#CDD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 320C220.8 320 192 291.2 192 256C192 220.8 220.8 192 256 192C291.2 192 320 220.8 320 256C320 291.2 291.2 320 256 320Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M509.867 288C505.6 320 496 349.867 481.067 377.6L467.2 372.267L449.067 333.867L257.067 264.534C248.534 261.334 244.267 251.734 247.467 243.201C250.667 234.668 260.267 230.401 268.8 233.601L460.8 302.934L499.2 284.801L509.867 288Z",
    fill: "#334A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.933 103.467L274.133 260.267C267.733 266.667 257.066 266.667 250.666 260.267C244.266 253.867 244.266 243.2 250.666 236.8L408.533 81.0671C414.933 74.6671 425.6 74.6671 432 81.0671C437.333 87.4671 437.333 97.0671 430.933 103.467Z",
    fill: "#40596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.867 66.133L395.733 116.267V50.133L445.867 0V66.133Z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.867 116.267L512 66.1328H445.867L395.733 116.267H461.867Z",
    fill: "#F1543F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/Achievement.dc51e51577444dbea3eec49e2df67832.svg";
export { ForwardRef as ReactComponent };